import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import speaker from '../asset/img/common/speaker_icon.svg';
import arrowUp from '../asset/img/common/arrow_up.svg';
import Typography from './common/Typography';
import msgInfo from '../asset/img/msg_info.svg';
import { getTaxChanger } from '../features/common/commonSlice';

const shouldForwardProp = prop => !['isExpanded'].includes(prop);

const CollapsibleBannerStyled = styled.div.withConfig({ shouldForwardProp })`
  border-radius: 10px;
  background: var(--Primary-50);
  display: flex;
  padding: 16px;
  flex-direction: column;
  gap: 4px;
  cursor: pointer; // 클릭 가능함을 표시
`;

const ArrowImage = styled.img.withConfig({ shouldForwardProp })`
  transition: transform 0.5s ease;
  transform: ${({ isExpanded }) => (isExpanded ? 'rotate(180deg)' : 'rotate(0deg)')};
`;

const DescriptionWrapper = styled.div.withConfig({ shouldForwardProp })`
  overflow: hidden;
  transition: max-height ${({ isExpanded }) => (isExpanded ? '0.5s' : '0.3s')} ease;
  max-height: ${({ isExpanded }) => (isExpanded ? '1000px' : '0')};
`;

const Line = styled.div`
  width: 100%;
  height: 1px;
  background: var(--Primary-200);
  margin: 16px 0;
`;

const SubButton = styled.div`
  display: flex;
  padding: 6px 15px;
  justify-content: center;
  align-items: center;
  color: var(--Primary-500);
  border: 1px solid var(--Primary-500);
  border-radius: 6px;
  text-align: center;
  width: fit-content;
`;

const TaxChangeSectionStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
`;

const CollapsibleBanner = ({ title, description }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isExpanded, setIsExpanded] = useState(true);
  const { isTaxChangePer } = useSelector(state => state.common);

  const handleTaxChangeOpen = e => {
    e.stopPropagation(); // 이벤트 버블링 방지
    navigate('/taxChangeAlert');
  };

  useEffect(() => {
    //세액변경알림
    if (sStorage.getItem('htmAlias') != 'payday') {
      dispatch(getTaxChanger());
    }
  }, []);

  return (
    <CollapsibleBannerStyled onClick={() => setIsExpanded(!isExpanded)}>
      <div
        className="displayFlex"
        style={{ gap: '8px', alignItems: 'flex-start', justifyContent: 'space-between' }}>
        <Typography variant="body2Bold">{title}</Typography>
        <ArrowImage alt="arrow" src={arrowUp} isExpanded={isExpanded} />
      </div>
      <DescriptionWrapper isExpanded={isExpanded}>
        <Typography variant="body2Medium" style={{ whiteSpace: 'pre-wrap' }}>
          {description}
        </Typography>
        {isTaxChangePer && <TaxChangeSection onClick={handleTaxChangeOpen} />}
      </DescriptionWrapper>
    </CollapsibleBannerStyled>
  );
};

export default CollapsibleBanner;

const TaxChangeSection = ({ onClick }) => {
  return (
    <TaxChangeSectionStyled>
      <Line />
      <div>
        <img src={msgInfo} />
      </div>
      <Typography variant="body2Bold" style={{ textAlign: 'center' }}>
        연말정산 결과에 변경 사항이 있습니다.
        <br />
        재계산된 세액 관련 안내문을 확인해 주세요.
      </Typography>
      <SubButton className="captionBold" onClick={onClick}>
        안내문보기
      </SubButton>
    </TaxChangeSectionStyled>
  );
};
